import React, { useEffect, useState } from 'react';
import { Menu } from 'antd';
import { MenuProps } from 'antd/lib/menu';
import { useLocation } from 'react-router-dom';
import { TMenu } from '../../config';
import { useAppServices } from '../../services';

function findRoot(menu: any, path: string): string | undefined {
  for (let i = 0; i < menu?.length; i++) {
    const root = menu[i];
    if (root?.path === path) {
      return root.key;
    }
    if (root?.children) {
      for (let j = 0; j < root.children.length; j++) {
        const menuItem = root.children[j];
        if (menuItem?.path === path) {
          return root.key;
        }
      }
    }
  }
  return undefined;
}

const isInGroup = (requiredRoles: string[], userRoles: string[]): boolean => {
  if (requiredRoles.length === 0) {
    return true;
  }
  return !!requiredRoles.find((role) => userRoles.includes(role));
};

export interface IMenuTemplateProps extends MenuProps {
  list?: TMenu[];
}

export const MenuTemplate = (props: IMenuTemplateProps): React.ReactElement => {
  const { list, selectedKeys, mode = 'inline', theme = 'dark' } = props;
  const location = useLocation();
  const { authProfile } = useAppServices();
  const [selected, setSelected] = useState<string[]>([]);
  const [expanded, setExpanded] = useState<string[]>([]);

  const onOpenChange = (openKeys: string[]) => {
    setExpanded([openKeys[openKeys.length - 1]]);
  };

  useEffect(() => {
    const openPath = () => {
      const path = location.pathname;
      const parse = path.substring(path.indexOf('/'), path.length);
      if (path.length > 0 && selected[0] !== parse) {
        setSelected([parse]);
      }
      const root = findRoot(list, parse);
      if (root && !expanded.includes(root)) {
        // setExpanded([root]);
      }
    };
    openPath();
    return openPath;
  }, [selected, location]);

  return (
    <Menu
      items={list?.filter((group) => isInGroup(group.roles ?? [], authProfile?.external_auth ?? []))}
      selectedKeys={selected || selectedKeys}
      openKeys={expanded}
      onOpenChange={onOpenChange}
      mode={mode}
      theme={theme}
      {...props}
    />
  );
};
